import React from 'react';
import { cn } from '@/lib/core/utils';

interface SectionHeaderProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  size?: 'sm' | 'md';
  className?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ 
  icon: Icon, 
  title, 
  size = 'sm',
  className
}) => (
  <div className={cn("flex items-center gap-2 pb-2", className)}>
    <Icon className={cn("text-primary", size === 'sm' ? "h-3 w-3" : "h-4 w-4")} />
    <h5 className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
      {title}
    </h5>
  </div>
);